export const COLORS = {
  LINKS: '#3e3a3a',
  SECTIONTITLE: '#a48b65',
  BACKGROUND: '#f9f9f9',
  WHITE: '#fff',
};
